import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/index.scss";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import UserAuthenticator from "./plugins/UserAuthenticator.js";
import axios from "axios";
import UserManager from "./plugins/UserManager.js";
import VueAxios from "vue-axios";
import { createI18n } from "vue-i18n";
import messages from "@intlify/unplugin-vue-i18n/messages";
import AppointmentManager from "./plugins/AppointmentManager";
import HelperFunctions from "./plugins/HelperFunctions";
import CustomChallengeManager from "./plugins/CustomChallengeManager";
import DateManager from "./plugins/DateManager";
import RouterPlugin from "./plugins/RouterPlugin";
import ApiInterceptorPlugin from "./plugins/ApiInterceptorPlugin";
import Vue3Lottie from "vue3-lottie";
import CompetitiveChallengeManager from "~/plugins/CompetitiveChallengeManager";
import SbkManager from "~/plugins/SbkManager";
import FeedManager from "~/plugins/FeedManager";

// Pinia Plugins
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

function PiniaDependencies() {
  return {
    UserManager: app.config.globalProperties.$userManager,
    i18n: app.config.globalProperties.$i18n,
  };
}

pinia.use(PiniaDependencies);

// i18n
const i18n = createI18n({
  locale: navigator.language.split("-")[0],
  globalInjection: true,
  fallbackLocale: "en",
  messages,
});

// order of router and api interceptor plugins is important
const app = createApp(App);
app.use(pinia);
app.use(VueAxios, axios);
app.use(UserAuthenticator);
app.use(RouterPlugin);
app.use(app.config.globalProperties.$routerPlugin.getRouter());
app.use(ApiInterceptorPlugin);
app.use(UserManager);
app.use(HelperFunctions);
app.use(FeedManager);
app.use(AppointmentManager);
app.use(CustomChallengeManager);
app.use(CompetitiveChallengeManager);
app.use(DateManager);
app.use(SbkManager);
app.use(i18n);
app.use(Vue3Lottie);

app.mount("#app");
